export enum DataValueType {
  ABSOLUTE = "Absolute",
  CHANGE = "Change",
  PREVIOUS = "Previous",
}

export const languageMapping: { [key: string]: string } = {
  "en": "en-US",
  "fi": "fi-FI",
  "sv": "sv-SE",
  "nb": "nb-NO",
  "English": "en-US",
  "Finnish": "fi-FI",
  "Swedish": "sv-SE",
  "Norwegian": "nb-NO",
};

export const Languages: { [key: string]: string } = {
  "en-US" : "English",
  "fi-FI" : "Finnish",
  "sv-SE" : "Swedish",
  "nb-NO" : "Norwegian",
}

export enum Visualizations {
  CHART = "Chart",
  TABLE = "Table",
  FIGURE = "Figure",
}

export enum DateFilter {
  YEARS = "Years",
  MONTHS = "Months",
  CUSTOM_PERIOD = "Custom Period",
  DEC_FEB = "Dec - Feb",
  MAR_MAY = "Mar - May",
  JUN_AUG = "Jun - Aug",
  SEP_NOV = "Sep - Nov",
  MAY_OCT = "May - Oct",
  NOV_APR = "Nov - Apr",
  JANUARY = "January",
  FEBRUARY = "February",
  MARCH = "March",
  APRIL = "April",
  MAY = "May",
  JUNE = "June",
  JULY = "July",
  AUGUST = "August",
  SEPTEMBER = "September",
  OCTOBER = "October",
  NOVEMBER = "November",
  DECEMBER = "December",
}

export enum Share {
  PRINT = "Print",
  PNG = "Image (png)",
  SVG = "Image (svg)",
  CSV = "CSV",
}

export enum ShareTable {
  CSV = "CSV",
  PNG = "Image (PNG)",
}

export enum ShareTableDaily {
  CSV = "CSV",
}

export enum HorizontalResize {
  SMALL = "Small",
  MEDIUM = "Medium",
  LARGE = "Large",
}

export enum VerticalResize {
  VERTICAL_SMALL = "Small",
  VERTICAL_LARGE = "Large",
}
